import { Box, Button, Dialog, IconButton } from "@mui/material";
import { useState } from "react";
import CloseModalButton from "../../../../components/CloseModalButton";
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from "../../../../components/Dialog.styled";
import InfoIcon from "@mui/icons-material/Info";

const ReferenceModal = ({ references }: { references: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => setIsOpen(false);
  return (
    <>
      <IconButton aria-label="open reference modal" onClick={() => setIsOpen(true)}>
        <InfoIcon fontSize="small" />
      </IconButton>
      <Dialog open={isOpen} onClose={onClose}>
        <CloseModalButton handleClose={onClose} />
        <StyledDialogTitle>
          <Box className="flex flex-align-center">
            Reference
          </Box>
        </StyledDialogTitle>
        <StyledDialogContent>
          {references}
        </StyledDialogContent>
        <StyledDialogFooter>
          <Button variant="outlined" size="small" onClick={onClose}>Close</Button>
        </StyledDialogFooter>
      </Dialog>
    </>
  );
};

export default ReferenceModal;